import React from 'react'
import {  Card, CardContent, CardHeader, Paper } from '@material-ui/core';

export default function LoggedOutScreen() {
    return (
        <Paper>
            <Card>
                <CardHeader>
                    <h1>you are logged out.</h1>
                </CardHeader>
                <CardContent>
                    <h3>Thank you.</h3>
                </CardContent>
            </Card>
        </Paper>
    )
}
